import type { HLPortfolio } from "../types"

export function getPerpsDailyPnl(portfolio?: HLPortfolio) {
  const latestPnl = portfolio?.perpDay?.pnlHistory?.at(-1)?.[1]
  return latestPnl ? Number(latestPnl) : 0
}

export function getPnlPercent(pnl: number, currentAccountValue: number) {
  const startingAccountValue = currentAccountValue - pnl
  return startingAccountValue ? (pnl / startingAccountValue) * 100 : 0
}
